export default __webpack_public_path__ + "static/media/Promotion.920db394.svg";